import { setPropertySchema } from '../../utils/helpers';
import { Buttons } from './buttons';

export class Dropdowns extends Buttons {
  dressDropdowns = () => {
    // get all dropdowns
    const selects = this.form.querySelectorAll('select');

    // for each dropdown dress with data attributes
    selects.forEach((select) => {
      // get dropdown name
      const name = this.getName(select);
      const blocked = this.isBlocked(select);

      // if name dress dropdown
      if (name) {
        // set element as dropdown
        select.setAttribute('data-fs-element', 'dropdown');
        // set dropdown name as it's name
        select.setAttribute('data-fs-dropdown-name', name.toLowerCase());

        // set property schema
        setPropertySchema(select);

        if (!blocked) {
          // dress options
          this.dressOptions(select);

          // add listener on change
          select.addEventListener('change', (e) => {
            // grab change value
            const value = e.target.value;
            // set value attribute
            select.setAttribute('data-fs-dropdown-value', value);

            // redress options
            this.dressOptions(select, value);

            // add value to button
            this.updateButton(name, value);

            // update property schema
            setPropertySchema(select);
          });
        }
      }
    });
  };

  dressOptions = (select, selected = null) => {
    // get all options on the select
    const options = select.querySelectorAll('option');

    // for each option dress with data properties
    options.forEach((option) => {
      // grab option value
      const value = option.value;

      // if value dress element
      if (value) {
        // set element as option
        option.setAttribute('data-fs-element', 'option');
        // set option value as value
        option.setAttribute('data-fs-option-value', value);
        // set option selected as boolean

        const isSelected = value === selected;
        option.setAttribute('data-fs-option-selected', isSelected.toString());

        // create schema
        setPropertySchema(option);
      }
    });
  };
}
